import { useMutation } from '@tanstack/react-query'
import { gql } from 'graphql-request'
import { MoreHorizontal } from 'lucide-react'

import { request } from '@helpers/graphql'
import { useFlashMessage } from '@components/FlashMessage'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"

const UPDATE_MEMBERSHIP_ROLE_MUTATION = gql`
  mutation updateMembershipRole($input: UpdateRoleInput!) {
    updateMembershipRole(input: $input) {
      membership {
        role
      }
      errors {
        message
      }
    }
  }
`

const EducatorListActions = ({ id, userId, email, fullName, role, refetch, organizationId }) => {
  const educatorNameOrEmail = fullName.trim() === '' ? email : fullName
  const { setFlashMessage } = useFlashMessage()

  const { mutate: updateEducatorRole } = useMutation({
    mutationFn: async (variables) => request(UPDATE_MEMBERSHIP_ROLE_MUTATION, variables, { 'X-Organization-Id': organizationId }),
    onSuccess: (data) => {
      if (data?.updateMembershipRole?.errors?.length > 0) {
        setFlashMessage(
          data.updateMembershipRole.errors.map(err => err.message).join(', '),
          'error'
        )
      } else {
        refetch()
      }
    },
    onError: (error) => {
      setFlashMessage(error.message || 'Failed to update educator role.', 'error')
    }
  })

  const handleRoleChange = (id, newRole) => {
    updateEducatorRole({
      input: {
        profileId: id,
        role: newRole
      }
    })
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" className="h-8 w-8 p-0">
          <span className="sr-only">Open menu</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <Choose>
          <When condition={role === 'ADMIN'}>
            <DropdownMenuItem onClick={() => handleRoleChange(id, 'EDUCATOR')}>
              Make {educatorNameOrEmail} an educator
            </DropdownMenuItem>
          </When>

          <Otherwise>
            <DropdownMenuItem onClick={() => handleRoleChange(id, 'ADMIN')}>
              Make {educatorNameOrEmail} an admin
            </DropdownMenuItem>
          </Otherwise>
        </Choose>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default EducatorListActions
